import { CheckboxInput } from '@frontend/components/basic-forms';
import React, { useEffect, useState } from 'react';

import { useFilterCheckboxCard } from './filter-checkbox-card.controller';

export interface FilterCheckboxCardProps {
    label: React.ReactNode;
    type: string;
    subset?: string[];
    selected: string[];
    selectedCallback?: (value: string[]) => void;
}

export const FilterCheckboxCard = (props: FilterCheckboxCardProps) => {
    const viewProps = useFilterCheckboxCard(props);
    const [entities, setEntities] = useState<{ value: any; label: any }[]>([]);

    const selected = props.selected || [];

    const handleToggle = (value: string, checked: boolean) => {
        if (props.selectedCallback) {
            if (checked) {
                props.selectedCallback([...selected, value]);
            } else {
                props.selectedCallback(selected.filter((i) => i !== value));
            }
        }
    };

    useEffect(() => {
        const fetchEntities = async () => {
            const init = await viewProps.getEntities(props.type);
            if (props.subset) {
                setEntities(init.filter((item) => props.subset?.includes(item.value)));
            } else {
                setEntities(init);
            }
        };
        fetchEntities();
    }, [props.type, props.subset]);

    return (
        <div className='inline-flex flex-col items-start justify-start gap-3 self-stretch rounded-2xl bg-white p-4'>
            <div className='w-96 justify-start text-base font-semibold text-stone-950'>{props.label}</div>
            <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                {entities.map((item) => (
                    <CheckboxItem
                        onClick={(checked) => handleToggle(item.value, checked)}
                        key={item.value}
                        display={item.label}
                        selected={selected.includes(item.value)}
                        id={item.value}
                    />
                ))}
            </div>
        </div>
    );
};

const CheckboxItem = (props: { id: string; display: React.ReactNode; selected: boolean; onClick: (value: boolean) => void }) => {
    return (
        <div className='inline-flex items-center justify-between self-stretch'>
            <div className='justify-start text-base font-medium text-stone-950'>{props.display}</div>
            <CheckboxInput
                value={props.selected}
                onChange={props.onClick}
                key={props.id}
                id={props.id}
            />
        </div>
    );
};
